import axios from "axios";
import { TranslationKey } from "./TranslationKey";

export type Translations = {
    [key in TranslationKey]: string;
};

const config = {
    headers: { Pragma: 'no-cache' }
}

/**
 * Retrieve a single translation value from the backend
 *
 * @param key The key of the translation to retrieve
 * @param config To clear the cache on IE
 */
export async function getTranslation(key: TranslationKey): Promise<string> {
    return await axios
        .get(`/Language/GetTranslations?key=${key}`, config)
        .then((r) => r.data);
}

/**
 * Get all translations from the backend in the current culture
 * @param config To clear the cache on IE
 * @returns
 */
export async function getTranslations(): Promise<Translations> {
    return await axios
        .get(`/Language/GetTranslations`, config)
        .then(r => r.data);
}
